var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDocumentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 64,
    viewBox: "0 0 74 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00676 1.92358C2.94613 1.92358 2.08301 2.78671 2.08301 3.84733V59.9214C2.08301 60.9827 2.94613 61.8452 4.00676 61.8452H70.0933C71.154 61.8452 72.0171 60.9827 72.0171 59.9214V3.84733C72.0171 2.78671 71.154 1.92358 70.0933 1.92358H4.00676ZM70.0936 63.1277H4.00703C2.2391 63.1277 0.800781 61.6894 0.800781 59.9215V3.84736C0.800781 2.07944 2.2391 0.641113 4.00703 0.641113H70.0936C71.8609 0.641113 73.2999 2.07944 73.2999 3.84736V59.9215C73.2999 61.6894 71.8609 63.1277 70.0936 63.1277Z",
    fill: "#106C3A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44238 9.61893H72.659V8.33643H1.44238V9.61893Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44393 4.98791C6.44393 5.57786 5.96555 6.05687 5.37496 6.05687C4.78501 6.05687 4.30664 5.57786 4.30664 4.98791C4.30664 4.39796 4.78501 3.91895 5.37496 3.91895C5.96555 3.91895 6.44393 4.39796 6.44393 4.98791Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0767 4.98791C10.0767 5.57786 9.59837 6.05687 9.00778 6.05687C8.41783 6.05687 7.93945 5.57786 7.93945 4.98791C7.93945 4.39796 8.41783 3.91895 9.00778 3.91895C9.59837 3.91895 10.0767 4.39796 10.0767 4.98791Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9244 4.98791C13.9244 5.57786 13.446 6.05687 12.8554 6.05687C12.2655 6.05687 11.7871 5.57786 11.7871 4.98791C11.7871 4.39796 12.2655 3.91895 12.8554 3.91895C13.446 3.91895 13.9244 4.39796 13.9244 4.98791Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0329 34.0077C33.8966 34.0077 34.5956 34.7073 34.5956 35.5659V41.8303C34.5956 42.1092 34.8226 42.3362 35.1015 42.3362H38.8926C39.1715 42.3362 39.3992 42.1092 39.3992 41.8303V35.5659C39.3992 34.7073 40.0981 34.0077 40.9568 34.0077L43.457 34.016L41.1248 31.519C40.7355 31.1022 40.1026 30.416 39.7179 29.9967L37.3049 27.3566C37.1362 27.1713 36.8579 27.1713 36.6886 27.3566L34.2762 29.9967C33.8915 30.416 33.2586 31.1022 32.87 31.519L30.5371 34.016L33.0329 34.0077ZM38.8923 43.3912H35.1012C34.2406 43.3912 33.5404 42.6909 33.5404 41.8304V35.566C33.5404 35.289 33.3147 35.0626 33.037 35.0626L30.3547 35.0709C29.6551 35.0709 29.4165 34.6952 29.3466 34.5336C29.2761 34.3713 29.1639 33.9411 29.6397 33.4313L32.0982 30.7989C32.4855 30.3847 33.1152 29.7037 33.4974 29.2843L35.9098 26.6456C36.1964 26.3307 36.5825 26.1582 36.9967 26.1582C37.4103 26.1582 37.797 26.3307 38.083 26.6456L40.496 29.2843C40.8782 29.7037 41.5079 30.3847 41.8952 30.7989L44.3538 33.4313C44.8296 33.9411 44.7174 34.3713 44.6468 34.5336C44.5769 34.6952 44.3384 35.0709 43.6446 35.0709L40.9584 35.0626C40.6788 35.0626 40.4531 35.289 40.4531 35.566V41.8304C40.4531 42.6909 39.7528 43.3912 38.8923 43.3912Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9971 18.8816C27.8624 18.8816 20.4316 26.313 20.4316 35.447C20.4316 44.5816 27.8624 52.0131 36.9971 52.0131C46.1317 52.0131 53.5625 44.5816 53.5625 35.447C53.5625 26.313 46.1317 18.8816 36.9971 18.8816ZM36.9973 53.2956C27.1554 53.2956 19.1494 45.2889 19.1494 35.447C19.1494 25.6051 27.1554 17.5991 36.9973 17.5991C46.8392 17.5991 54.8452 25.6051 54.8452 35.447C54.8452 45.2889 46.8392 53.2956 36.9973 53.2956Z",
    fill: "#106C3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocumentation);
export default __webpack_public_path__ + "static/media/upload_documentation.dbf434a40b16177c8877e60839590914.svg";
export { ForwardRef as ReactComponent };